import { useState } from 'react'

import {
  Combobox,
  ComboboxChip,
  ComboboxChips,
  ComboboxChipsInput,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  useComboboxAnchor,
} from '@/components/ui/combobox'
import { Demo, DsSection } from '../primitives'

const STATES = ['Arizona', 'California', 'Nevada', 'New Mexico', 'Oregon', 'Texas', 'Utah', 'Washington']

function StateItems() {
  return (
    <>
      <ComboboxEmpty>No matches</ComboboxEmpty>
      <ComboboxList>
        {(item: string) => (
          <ComboboxItem key={item} value={item}>
            {item}
          </ComboboxItem>
        )}
      </ComboboxList>
    </>
  )
}

function SingleValueDemo() {
  const [state, setState] = useState<string | null>(null)

  return (
    <Combobox items={STATES} value={state} onValueChange={setState}>
      <ComboboxInput placeholder="Pick a state" aria-label="State" className="max-w-sm" />
      <ComboboxContent>
        <StateItems />
      </ComboboxContent>
    </Combobox>
  )
}

function ChipsDemo() {
  const anchor = useComboboxAnchor()
  const [states, setStates] = useState<string[]>(['Texas'])

  return (
    <Combobox multiple items={STATES} value={states} onValueChange={setStates}>
      <ComboboxChips ref={anchor} className="max-w-sm">
        {states.map((item) => (
          <ComboboxChip key={item} removeLabel={`Remove ${item}`}>
            {item}
          </ComboboxChip>
        ))}
        <ComboboxChipsInput
          aria-label="States"
          placeholder={states.length === 0 ? 'Pick states' : undefined}
        />
      </ComboboxChips>
      <ComboboxContent anchor={anchor}>
        <StateItems />
      </ComboboxContent>
    </Combobox>
  )
}

export function ComboboxSection() {
  return (
    <DsSection
      id="combobox"
      title="Combobox"
      intro="Type to filter a long list and pick from it: one value with ComboboxInput, several with ComboboxChips. Give each chip a removeLabel such as “Remove Texas”. For free-text tags, use Tag input."
    >
      <Demo label="One value — ComboboxInput">
        <SingleValueDemo />
      </Demo>
      <Demo label="Several values — ComboboxChips">
        <ChipsDemo />
      </Demo>
    </DsSection>
  )
}
